import clsx from 'clsx'
import Switch from 'components/Switch'
import usePayment from 'utils/hooks/usePayment'
import Typography from 'components/Typography'
import TariffCard from 'components/TariffCard'
import iconArrowLeft from 'assets/svg/arrow-left.svg'
import LoadingWrapper from 'components/LoadingWrapper'
import { t } from 'utils/localization'
import { PLANS } from 'utils/enums'
import { useState } from 'react'
import { useProfile } from 'utils/hooks/useContext'
import { TPlan, TPlanPrice } from 'utils/types'

import './styles.scss'

interface TariffSelectProps {
  showNav?: boolean
  switchId?: string
}

const TariffSelect: React.FC<TariffSelectProps> = (props) => {
  const { showNav, switchId } = props

  const profile = useProfile()
  const payment = usePayment()

  const [showYearPlan, setShowYearPlan] = useState<boolean>(false)

  const renderCard = (id: TPlan, price: TPlanPrice) => {
    if (id === 'enterprise') {
      return null
    }

    const plan = profile.plans.find((p) => p.id === id)

    if (!plan) {
      return null
    }

    return (
      <TariffCard
        key={id}
        plan={plan}
        main={id === 'indie'}
        price={price}
        onSelect={payment.payForPlan}
        annualSubscription={showYearPlan}
      />
    )
  }

  return (
    <LoadingWrapper isLoading={payment.isLoading}>
      <div className={clsx('b-tariffs', showYearPlan && 'b-tariffs--blue')}>
        <div className='b-tariffs__inner'>
          {!!showNav && (
            <div className='b-tariffs__nav'>
              <button
                id='skipPlanSelect'
                type='button'
                onClick={() => payment.payForPlan(PLANS.free.id)}
              >
                <Typography color='grey'>{t('continue')}</Typography>
                <img src={iconArrowLeft} alt='' />
              </button>
            </div>
          )}

          <Typography as='h1' size='lg' weight='bold' centered>
            {t('select-tariff')}
          </Typography>

          <div className='b-tariffs__switch'>
            <Typography color={showYearPlan ? 'black' : 'primary'}>
              {t('month')}
            </Typography>

            <Switch
              name={switchId || 'paymentPeriod'}
              checked={showYearPlan}
              onChange={setShowYearPlan}
            />

            <Typography color={showYearPlan ? 'primary' : 'black'}>
              {t('year')} (-20%)
            </Typography>
          </div>

          <div className='b-tariffs__cards'>
            {Object.entries(PLANS).map(([key, price]) =>
              renderCard(key as TPlan, price)
            )}
          </div>
        </div>
      </div>

      {payment.ModalComponent}
    </LoadingWrapper>
  )
}

export default TariffSelect
